import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { getNodeManager } from "@src/cloud-connect/dependency-injection-container/get-node-manager";
import { FilterModalObj } from "./filter-modal-obj";
import { getLogger } from "@src/cloud-connect/dependency-injection-container/get-logger";
import { useI18N } from "@src/language/language-context";

export const useNewMachineFilterModalHook = (): FilterModalObj => {
  const logger = getLogger();
  const i18n = useI18N();
  const texts = {
    filterSubtitle: i18n("modules.machineStructureFilter.subtitle"),
    labelText: i18n("modules.machineStructureFilter.labelText"),
    textAreaPlaceholder: i18n(
      "modules.machineStructureFilter.textAreaPlaceholder",
    ),
    showResults: i18n("modules.machineStructureFilter.showResults"),
    clearFilter: i18n("modules.machineStructureFilter.clearFilter"),
  };

  const filterInputContent = useSelector(
    (state: RootState) =>
      state.yourSlice.machineStructureFilterModal.filterInputContent,
  );

  const [localFilterInputContent, setLocalFilterInputContent] = useState("");

  const nodeManager = getNodeManager();

  const handlecloseModal = () => {
    logger.debug("useNewMachineFilterModalHook", {
      function: "handlecloseModal",
    });
    nodeManager.closeMachineStructureFilterModal();
  };

  const handleShowResultsClick = () => {
    logger.debug("useNewMachineFilterModalHook", {
      function: "handleShowResultsClick",
    });
    nodeManager.handleShowResultsClickInMachineFilterModal(
      localFilterInputContent,
    );
  };

  const handleClearFilterClick = () => {
    logger.debug("useNewMachineFilterModalHook", {
      function: "handleClearFilterClick",
    });
    nodeManager.handleClearNewFilterClickInMachineFilterModal();
  };

  useEffect(() => {
    setLocalFilterInputContent(filterInputContent || "");
  }, []);

  return {
    handlecloseModal: handlecloseModal,
    handleShowResultsClick: handleShowResultsClick,
    handleClearFilterClick: handleClearFilterClick,
    setLocalFilterInputContent: setLocalFilterInputContent,
    localFilterInputContent: localFilterInputContent,
    texts: texts,
  };
};
